import React from "react";
import Layout from "../components/Layout/Layout";
import { Link } from "react-router-dom";
import "./Home+.css";

// Importa los componentes secundarios
import MiniLayout from "./Section";
import Mapa from "../components/Layout/Mapa";
import Horarios from "../components/Piaces/Horarios";
import Figura from "../components/Piaces/Figura";

// Importa el logo (se mostrará en mayor tamaño)
import logoAsia from "../images/logo_asia-removebg-preview.png"; 

const Home = () => {
  return (
    <Layout>
      {/* HEADER: La imagen con fondo negro y el botón debajo */}
      <header className="home-hero-section">
        <div className="hero-image-container">
          <img 
            src={logoAsia} 
            alt="Logo Restaurante Asia" 
            className="hero-image" 
          />
        </div>
        <div className="hero-button-container">
          <Link to="/menu" className="hero-button">
            Ver Menú
          </Link>
        </div>
      </header>

      {/* CONTENIDO ADICIONAL */}
      <MiniLayout />

      <section className="dark-section">
        <div className="dark-section-content">
          <h1 className="dark-section-title">
            Restaurante Chino Asia: verdadera comida china en las Palmas del Poblado, Medellín
          </h1>
          <p className="dark-section-subtitle">
            Domicilios para Sabaneta, La Estrella, Laureles, Envigado, Mall Indiana, Bello, Belén, Aranjuez, Itagüí y más.
          </p>
        </div>
      </section>

      <Figura />

      <section className="dark-section">
        <div className="salon-card">
          <h2 className="salon-title">Comer en el Salón</h2>
          <p className="salon-description">
            Disfruta de una comida en nuestro acogedor salón. Un ambiente ideal para saborear nuestros platos.
          </p>
          <Link to="/Salon" className="salon-button">Ver más</Link>
        </div>
      </section>

      <section className="dark-section">
        <Horarios />
      </section>

      <Figura />

      <section className="dark-section">
        <Mapa />
      </section>

      <section className="dark-section">
        <div className="info-container">
          <h2 className="dark-section-title" style={{ marginBottom: "0.5rem" }}>
            ¡Descubre el Sabor Único del Arroz Chino en Medellín!
          </h2>
          <p className="dark-section-subtitle">
            Nuestro exquisito <strong>arroz chino</strong> y <strong>chopsuey</strong> están preparados con auténticos sabores e ingredientes frescos.
            Si prefieres disfrutar de nuestros platos en la comodidad de tu hogar,
            también ofrecemos servicio a domicilio para todo el Valle de Aburra.
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default Home;
